exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.css-printer {\n  float: right;\n  position: relative;\n  /*z-index: 9!important;*/\n  top: -25px;\n}\n.css-printer button.el-button {\n  border: none;\n  padding: 0;\n  margin: 0 20px 0 20px;\n}\n", ""]);

// exports
